import ContractList from './ContractList.vue';

export default ContractList;
